import { render, staticRenderFns } from "./FormDescarte.vue?vue&type=template&id=b0b0e296&"
import script from "./FormDescarte.vue?vue&type=script&lang=js&"
export * from "./FormDescarte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports